<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="unidades-medida vertical-flow">
                    <!-- TÍTULO -->
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("unidades-medida") }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("unidades-medida")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !unidademedidaIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: 'ven-unidade-medida-new',
                                    })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="um-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allunidades"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="
                                    f.key != 'excluir' ? $t(f.key) : ''
                                "
                                :width="f.width"
                                :class="
                                    f.key != 'excluir' ? '' : 'excluir-field'
                                "
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >

                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete&&!unidademedidaIntegracao"
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'
                                        "
                                        @click="
                                            promptChangeSituacao(
                                                props.row
                                            )
                                        "
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>

                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'ven-unidade-medida-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t("ativo") }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t("inativo") }}</b-tag
                                    >
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import UnidadeMedidaService from "@/services/UnidadeMedidaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if(to.name == 'ven-unidade-medida-new' || to.name == 'ven-unidade-medida-edit'){
            this.rotaAninhada = true;
            next()
        }else{
            this.rotaAninhada = false;
            this.carregarDados();
            next()
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            unidademedidaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("UNIDADEMEDIDA"),
            allunidades: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            service: new UnidadeMedidaService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: '10%', sortable: true },
                { key: "descricao", width: null, sortable: true, sortFn: null },
                { key: "situacao", width: 80, sortable: false, sortFn: null },
                { key: "excluir", width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            sort: "descricao",
            order: "asc",
            delete: null,
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        if(this.$route.name == 'ven-unidade-medida-new' || this.$route.name == 'ven-unidade-medida-edit'){
            this.rotaAninhada = true;
        }else{
            this.rotaAninhada = false;
        }

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "venda-unidades-medida"
        );
        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "unidades-medida" },
            });
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        sortTable(field, order) {
            this.sort = field;
            this.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.order,
                    this.sort,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allunidades = value;
                    this.isEmpty = this.allunidades.length <= 0;
                })
                .catch((e) => {
                    console.error(
                        "Erro ao carregar listagem de unidades de medida.",
                        e
                    );
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load-uns-medida");
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let unidadelist = body.content
                ? body.content.map((m) => {
                    return {
                        id: m.idunidademedida,
                        codigo: m.idunidademedidaerp,
                        descricao: m.descricao,
                        excluir: "excluir-marca",
                        situacao: m.situacao,
                    };
                })
                : [];

            return unidadelist;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },

        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-unidademedida"
                    : "msg-erro-ao-reativar-unidademedida";

            let tempUnidadeMedida = {
                idunidademedida: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(tempUnidadeMedida)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-unidademedida"
                                : "msg-sucesso-ao-desativar-unidademedida";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .data-table {
        padding: 0;
    }

    .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;

        .search-bar {
            width: 100%;
        }
    }
}
</style>